define('connections/cart-connection',['jquery', 'utils/ajax-util', 'settings'], function ($, ajax, settings) {
  /**
   * @class Cart
   */
  return (function () {
    /**
     * @constructor
     */
    function CartConnection() { }

    /**
     * Property used to check if the cart view is up to date
     *
     * @property cartViewLoaded
     * @type {boolean}
     */
    CartConnection.prototype.cartViewLoaded = false;

    CartConnection.prototype.setCartViewLoaded = function (isLoaded) {
      var _this = this;

      _this.cartViewLoaded = isLoaded;
    };

    /**
     * Add items to cart by posting sku- and quantity lists
     *
     * @method add
     * @param data
     * @returns {promise}
     */
    CartConnection.prototype.add = function (data) {
      var _this = this;

      return ajax.post(settings.cartApiUrl + '/addtocart', { skuQuantityList: data }, function () {
        _this.setCartViewLoaded(false);
      });
    };

    /**
     * Change quantity on sku(s)
     *
     * @method change
     * @param sku, qty
     * @returns {promise}
     */
    CartConnection.prototype.changeQuantity = function (sku, qty, cartId) {
      var _this = this;

      return ajax.post(settings.cartApiUrl + '/changeitemquantity', { sku: sku, quantity: qty, cartId: (cartId ? parseInt(cartId) : null) }, function () {
        _this.setCartViewLoaded(false);
      });
    };

    CartConnection.prototype.changeComment = function (sku, comment) {
      return ajax.post(settings.cartApiUrl + '/changeitemcomment', { sku: sku, comment: comment });
    };

    CartConnection.prototype.changeDate = function (skus, date, cartId) {
      return ajax.post(settings.cartApiUrl + '/changeitemdate', { skuList: skus, date: date, cartId: (cartId ? parseInt(cartId) : null) });
    };

    CartConnection.prototype.setCampaignCode = function (code) {
      return ajax.post(settings.cartApiUrl + '/setcampaigncode', { code: code });
    };

    CartConnection.prototype.removeCampaignCode = function () {
      return ajax.post(settings.cartApiUrl + '/removecampaigncode');
    };

    /**
     * Delete product
     *
     * @method deleteProduct
     * @param pid - the product to remove
     * @returns {promise}
     */
    CartConnection.prototype.deleteProduct = function (pid) {
      var _this = this;

      return ajax.delete(settings.cartApiUrl + '/deleteproduct', { productNumber: pid }, function () {
        _this.setCartViewLoaded(false);
      });
    };

    /**
     * Clear the entire cart
     *
     * @method clear
     * @returns {*}
     */
    CartConnection.prototype.clear = function () {
      var _this = this;

      return ajax.delete(settings.cartApiUrl + '/deletecart', null, function () {
        _this.setCartViewLoaded(false);
      });
    };

    /**
     * Get the QuickCart partial view
     *
     * @method getQuickCart
     * @returns {*}
     */
    CartConnection.prototype.getQuickCart = function () {
      var _this = this;
      //return ajax.get(settings.cartApiUrl + '/quickcart', false, null, this.setCartViewLoaded(true));

      return $.ajax({
        url: settings.quickCartApiUrl,
        type: 'GET',
        cache: false,
        success: function () {
          _this.setCartViewLoaded(true);
        }
      });
    };

    /**
     * Get the Cart partial view
     *
     * @method getCart
     * @returns {promise}
     */
    CartConnection.prototype.getLargeCart = function (sku, cartId, selectedPaymentMethod) {
      return $.ajax({
        url: settings.largeCartApiUrl + (sku ? '&sku=' + sku : '') + (selectedPaymentMethod ? '&selectedPaymentMethod=' + selectedPaymentMethod : '') + (cartId ? '&cartId=' + cartId : ''),
        type: 'GET',
        cache: false
      });
    };

    /**
     * Get total quantity
     *
     * @method getTotalQuantity
     * @returns {*}
     */
    CartConnection.prototype.getTotalQuantity = function () {
      //return ajax.get(settings.cartApiUrl + '/totalquantity');

      return $.ajax({
        url: settings.cartApiUrl + '/totalquantity',
        type: 'GET',
        cache: false
      });
    };

    /**
     * Update order header from cart page
     */
    CartConnection.prototype.updateOrderHeader = function (header) {
      return $.ajax({
        url: settings.currentPageURL + '/orderheader',
        type: 'POST',
        data: header,
        cache: false
      });
    };

    CartConnection.prototype.getAdyenPaymentMethods = function () {
      return $.ajax({
        url: settings.cartApiUrl + '/GetAdyenPaymentMethods',
        type: 'GET',
        cache: false
      });
    };

    CartConnection.prototype.adyenMakePayment = function (pData, clientOrderNumber) {

      var paymentData = JSON.stringify(pData);
      return $.ajax({
        url: settings.cartApiUrl + '/AdyenMakePayment?clientOrderNumber=' + clientOrderNumber,
        type: 'POST',
        data: { "paymentData": paymentData },
        cache: false
      });
    };

    CartConnection.prototype.adyenMakeDetailsCall = function (data, clientOrderNumber) {
      return $.ajax({
        url: settings.cartApiUrl + '/AdyenMakeDetailsCall?clientOrderNumber=' + clientOrderNumber,
        type: 'POST',
        data: data,
        cache: false
      });
    };

    CartConnection.prototype.getShopperLocale = function () {
      return $.ajax({
        url: settings.cartApiUrl + '/GetShopperLocale',
        type: 'GET',
        cache: false
      });
    };

    return new CartConnection();
  })();
});

